import { ArrowLeft, Home } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <div className="max-w-md rounded-2xl border border-blue-100 bg-white p-6 shadow-sm text-center">
        <h1 className="text-3xl font-bold text-slate-900">404</h1>
        <p className="mt-2 text-sm font-semibold text-slate-600">
          Page not found
        </p>

        <div className="mt-6 flex justify-center gap-3">
          {/* <button
            onClick={() => navigate(-1)}
            className="rounded-xl border border-blue-200 px-4 py-2 text-sm font-semibold text-blue-700"
          >
            <ArrowLeft className="inline h-4 w-4" /> Back
          </button> */}

          <button
            onClick={() => navigate("/")}
            className="rounded-xl bg-blue-600 px-4 py-2 text-sm font-semibold text-white"
          >
            <Home className="inline h-4 w-4" /> Home
          </button>
        </div>
      </div>
    </div>
  );
}
